// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleButton_root__1JMFo","btn":"ToggleButton_btn__B1lDU","checkbox":"ToggleButton_checkbox__byMy4","knob":"ToggleButton_knob__eDYki","btnBg":"ToggleButton_btnBg__TOPRq"};